// This is a one off request for the NPR portal EXT-370

import React from 'react';
import Script from 'next/script';
import { getNonce } from '@/lib/nonce';

export type PodsightsScriptProps = {
  sdkKey: string;
  nonce?: string;
};

// Removed inline builder; using external src + minimal inline init with nonce below

export default function PodsightsScript({ sdkKey, nonce }: PodsightsScriptProps) {
  if (!sdkKey) return null;

  const resolvedNonce = nonce ?? getNonce();

  return (
    <>
      <Script id="podsights-loader" strategy="afterInteractive" nonce={resolvedNonce} src="https://cdn.pdst.fm/ping.min.js" />
      <Script
        id="podsights-init"
        strategy="afterInteractive"
        nonce={resolvedNonce}
        dangerouslySetInnerHTML={{
          __html: `
            (function(w){
              w.pdst = w.pdst || function() {(w.pdst.q = w.pdst.q || []).push(arguments)};
              w.pdst('conf', { key: '${sdkKey}' });
              w.pdst('view');
            })(window);
          `,
        }}
      />
    </>
  );
}
